import { render, staticRenderFns } from "./Laptop.vue?vue&type=template&id=ba993e54&scoped=true&"
import script from "./Laptop.vue?vue&type=script&lang=js&"
export * from "./Laptop.vue?vue&type=script&lang=js&"
import style0 from "./Laptop.vue?vue&type=style&index=0&id=ba993e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba993e54",
  null
  
)

export default component.exports